export const getBase64 = async (files) => {
    const reader = new FileReader();
    const [file] = files;
    const base64File = {
        base64: '',
        name: ''
    };
    reader.readAsDataURL(file);
    await new Promise(resolve => reader.onload = () => resolve(reader.result));
    base64File.base64 = reader.result;
    base64File.name = file.name;
    return base64File;
};
